import { configure } from '../routes'

export default function() {
  const params = new URLSearchParams(window.location.search)
  const defaultUrlOptions = params.has('pretend_to_be') ? { pretend_to_be: params.get('pretend_to_be') } : {}
  configure({
    default_url_options: defaultUrlOptions,
  })
}
